/**
 * Map a Firebase Auth error to a friendly, translated message.
 * Never surfaces the raw Firebase error string to the user.
 *
 * @param {unknown} error - the caught error (Firebase AuthError or other)
 * @param {(key: string) => string} t - i18next translation function
 * @returns {string} a user-facing message
 */
export function getAuthErrorMessage(error, t) {
  const code = error && error.code ? String(error.code) : '';

  const map = {
    'auth/invalid-credential': 'auth.errors.invalidCredentials',
    'auth/invalid-login-credentials': 'auth.errors.invalidCredentials',
    'auth/wrong-password': 'auth.errors.wrongPassword',
    'auth/user-not-found': 'auth.errors.userNotFound',
    'auth/invalid-email': 'auth.errors.invalidEmail',
    'auth/user-disabled': 'auth.errors.userDisabled',
    'auth/too-many-requests': 'auth.errors.tooManyRequests',
    'auth/email-already-in-use': 'auth.errors.emailInUse',
    'auth/weak-password': 'auth.errors.weakPassword',
    'auth/network-request-failed': 'auth.errors.network',
  };

  return t(map[code] || 'auth.errors.generic');
}
